// Entry module — deliberately tiny (no static React/App import) so it never
// blocks the first paint. The CSS import lets Vite emit the stylesheet (the
// prerender step inlines it). We boot the app only AFTER the browser has painted
// the prerendered hero (the LCP): requestAnimationFrame fires *before* paint, so
// booting there runs react + hydration + Clerk as one long task that blocks the
// LCP paint (the ~1.7s "element render delay"). requestIdleCallback fires once the
// main thread is idle *after* the paint, so the LCP is recorded first.
//
// 1e1d7e7 made this wait for a reported first contentful paint plus the hero image
// as well, with a 4 s fallback. A page whose prerendered shell paints nothing
// contentful (/search, /book) never reports that paint, so it sat blank until the
// fallback fired. Reverted on 2026-10-07; do not gate boot on FCP again.
import "./index.css";
import { localeFromPath, DEFAULT_LOCALE } from "@/lib/locale";
import { loadDictionary } from "@/locales";
import { loadScriptFont } from "@/lib/script-font";

const lang = localeFromPath(location.pathname) ?? DEFAULT_LOCALE;

let booted = false;
function boot() {
  if (booted) return;
  booted = true;
  // The dictionary is requested alongside the app, not after it; boot.tsx awaits
  // the same promise before it renders.
  void loadDictionary(lang);
  import("./boot");
  loadScriptFont();
}

if (typeof requestIdleCallback === "function") {
  requestIdleCallback(boot, { timeout: 2000 });
} else {
  setTimeout(boot, 200);
}
